import {
  Component,
  GetComponentsResponse,
  RootCpntIchr,
} from "../../services/components/get-components/GetComponentsResponse";
import { ErrorSpreadsheetResult } from "../../util";
import { Option } from "../../util/option";

export type ComponentListPageState = {
  searchResult: GetComponentsResponse;
  dataList: DataList;
  displayColumn: Option[];
  editDataList: {
    cpntOwnType: Option[];
    cpntAlctnType: Option[];
    clodSrvc: Option[];
    clodSrvcRgn: Option[];
  };
};

export type PicAddressSpreadsheetState = {
  results: RootCpntIchr[];
};

export type ComponentInfoSpreadsheetRow = ComponentInfo &
  ErrorSpreadsheetResult;

export type ComponentListSpreadsheetState = {
  componentList: ComponentInfoSpreadsheetRow[];
  dataList: DataList;
};

export type DataList = {
  inDefCommonFlagType: Option[];
};
export type ComponentInfo = {
  isEdited: boolean;
  component: Component;
};

export type PageNewState =
  | ComponentListPageState
  | ((prevState: ComponentListPageState) => ComponentListPageState);
